import React from "react";
import { Link } from "react-router-dom";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWallet, faPlus } from "@fortawesome/free-solid-svg-icons";
import { CURRENCY_TEXT, LANGUAGE, getCurrencyIconUrl } from "services/general";
import FormattedAmount from "./FormattedAmount";
import { useProfile } from "api/shared";
import { WALLET_INDEX } from "permissions";
import { HAS_PERMISSION, user } from "services/user";

/**
 * Top-bar wallet pill — balance plus a rounded "add funds" affordance (top-bar
 * design). Light mode uses a soft primary tint; the navy chrome uses a
 * translucent well with a cyan wallet glyph and a solid primary add button.
 */
const WalletBalanceBox = ({ isDark }) => {
  const { t } = useTranslation();
  const { data: profile } = useProfile();

  if (!HAS_PERMISSION(WALLET_INDEX)) {
    return null;
  }
  const currency = user?.agent?.currency;
  const currencyIconUrl = getCurrencyIconUrl(isDark);

  return (
    <Tooltip title={t("wallet.pageTitle")}>
      <Link
        to={`/${LANGUAGE}/wallet`}
        className={`hidden sm:flex items-center gap-2 h-10 ps-4 pe-1.5 rounded-full transition-colors shrink-0 ${
          isDark
            ? "bg-white/[0.08] border border-white/[0.14] hover:bg-white/[0.14]"
            : "bg-primary-bg-soft hover:bg-primary-tint"
        }`}
      >
        <FontAwesomeIcon
          icon={faWallet}
          className={`text-[16px] ${isDark ? "text-[#43c3da]" : "text-primary"}`}
        />
        <span
          className={`font-bold text-[14px] leading-none nums-font ${
            isDark ? "text-white" : "text-primary"
          }`}
          dir="ltr"
        >
          <FormattedAmount
            value={profile?.wallet?.balance ?? 0}
            suffix={
              currencyIconUrl ? (
                <img
                  src={currencyIconUrl}
                  alt={currency?.code ?? ""}
                  className="inline-block w-[1.17em] h-[1.17em] ms-1 align-middle"
                />
              ) : (
                CURRENCY_TEXT
              )
            }
          />
        </span>
        <span
          className={`w-7 h-7 rounded-full flex items-center justify-center ${
            isDark ? "bg-primary text-white" : "bg-surface text-primary"
          }`}
        >
          <FontAwesomeIcon icon={faPlus} className="text-[14px]" />
        </span>
      </Link>
    </Tooltip>
  );
};

export default WalletBalanceBox;
